import menu from '../images/menu.jpeg';
import cart from '../images/cart.jpeg';
import cocktails from '../images/cocktails.jpeg';
import color_gen from '../images/color_gen.jpeg';
import tours from '../images/tours.jpeg';
import birthday from '../images/birthday.jpeg';
import questions from '../images/questions.jpeg';


const cards =[
    {
       id:1,
       title:"Birthday Reminder",
       netlify:"https://pensive-albattani-887702.netlify.app",
        github:"https://github.com/harsh0056/full-website/tree/main/birthday%20reminder",
        url:birthday, 
    },
    {
        id:2,
        title:"Shopping Cart",
        netlify:"https://distracted-hamilton-fa9685.netlify.app/",
        github:"https://github.com/harsh0056/React-Projects/tree/master/shopping%20cart%20project",
        url:cart, 
     },
     {
        id:3,
        title:"My Tours",
        netlify:"https://serene-mcclintock-299f2c.netlify.app",
        github:"https://github.com/harsh0056/React-Projects/tree/master/tours",
        url:tours, 
     },
     {
        id:4,
        title:"Food Menu",
        netlify:"https://dazzling-hopper-b521f3.netlify.app/",
        github:"https://github.com/harsh0056/React-Projects/tree/master/submenus%20project",
        url:menu, 
     },
     {
        id:5,
        title:"Color Generator",
        netlify:"https://nifty-bose-e10de9.netlify.app/",
        github:"https://github.com/harsh0056/React-Projects/tree/master/color%20generator%20project",
        url:color_gen, 
     },
     {
        id:6,
        title:"Cocktails",
        netlify:"https://suspicious-blackwell-190fde.netlify.app/",
        github:"https://github.com/harsh0056/full-website/tree/main/full%20responsive%20cocktails%20website",
        url:cocktails, 
     },
     {
        id:7,
        title:"Questions",
        netlify:"https://youthful-hodgkin-0dc80a.netlify.app/",
        gthub:"https://github.com/harsh0056/React-Projects/tree/master/reviews",
        url:questions, 
     }
]

export default cards;